import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useEffect, useRef } from "react";
import { useDayPicker } from "react-day-picker";
import { useIntersection } from "react-use";
export var CustomMonthsContext = /*#__PURE__*/ createContext({
    onScrollToBottom: undefined,
    vertical: false
});
export var CustomMonths = function(param) {
    var children = param.children;
    var bottomRef = useRef(null);
    var ref = useContext(CustomMonthsContext), onScrollToBottom = ref.onScrollToBottom, vertical = ref.vertical;
    var intersection = useIntersection(bottomRef, {
        root: null,
        threshold: 0.5
    });
    useEffect(function() {
        // Only call the callback after rendering has finished
        if ((intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting) && vertical) {
            onScrollToBottom === null || onScrollToBottom === void 0 ? void 0 : onScrollToBottom();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting,
        vertical
    ]);
    var ref1 = useDayPicker(), classNames = ref1.classNames, styles = ref1.styles;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames.months,
        style: styles.months,
        children: [
            children,
            /*#__PURE__*/ _jsx("div", {
                ref: bottomRef
            })
        ]
    });
};
